import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas, logger } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formName = Routes.STEPFOUR;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 4',
    eventLabel: 'Amortization Rate'
};

const downPaymentMin = 1;

const validate = values => v(values, {
    downPayment: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        numericality: {
            greaterThanOrEqualTo: downPaymentMin,
            notGreaterThanOrEqualTo: 'must be greater than $0',
        }
    }
});

class StepFourForm extends Component {
    componentDidMount() {
        logger.logUserAction('form_step_loaded', 'MortgageCalculator-Step4', {
            step: 4,
            formName: formName,
            url: window.location.href
        });
    }

    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 4', {
                step: 4,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    type='text'
                    name='downPayment'
                    label='Desired Down Payment Amount'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                    onChange={(event, newValue, previousValue) => {
                        if (newValue !== previousValue) {
                            logger.logUserAction('field_changed', 'MortgageCalculator-Step4', {
                                step: 4,
                                field: 'downPayment',
                                previousValue,
                                newValue
                            });
                        }
                    }}
                />
            </form>
        );
    }
}

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step4', values, true);
        return result;
    } catch (error) {
        logger.error('Step 4 form submission failed', {
            step: 4,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepFourForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit: enhancedOnSubmit,
    initialValues: {
        downPayment: 0
    },
    redirectPath: `/mortgage${Routes.STEPFIVE}`,
    tracking: () => trackingEvent(tracking)
})(StepFourForm);

export default withRouter(StepFourForm);
